import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class ReasonForExecutorship extends Enum {
  key!: string;
  value!: string;

  static DEATH: ReasonForExecutorship = {
    key: 'death',
    get value(): string {
      return Lang.t('guidancestep.they-are-deceased');
    }
  };

  static DISABLED: ReasonForExecutorship = {
    key: 'disabled',
    get value(): string {
      return Lang.t('guidancestep.they-are-disabled');
    }
  };

  static MINOR: ReasonForExecutorship = {
    key: 'minor',
    get value(): string {
      return Lang.t('guidancestep.they-are-a-minor');
    }
  };

  static RENUNCIATION: ReasonForExecutorship = {
    key: 'renunciation',
    get value(): string {
      return Lang.t('estateaccount.appointed-wish-to');
    }
  };

  static OTHER: ReasonForExecutorship = {
    key: 'other',
    get value(): string {
      return Lang.t('guidancestep.other');
    }
  };

  static getReasonsUnableToAct<ReasonForExecutorship>(): ReasonForExecutorship[] {
    const values: ReasonForExecutorship[] = super.getValues<ReasonForExecutorship>();
    return values.filter(
      // @ts-ignore
      (value: ReasonForExecutorship): boolean => value.key !== this.RENUNCIATION.key
    );
  }
}
